import { InputHTMLAttributes, forwardRef, Ref, ReactNode } from 'react';
import { GenericInput, GenericInputProps } from './GenericInput';

interface Props extends InputHTMLAttributes<HTMLInputElement> {}

export const Input = forwardRef(
  (props: Props & Partial<GenericInputProps>, ref: Ref<any>) => {
    return <GenericInput component="input" {...props} ref={ref} />;
  },
);
